import { type FC } from 'react';
import {
  createBrowserRouter,
  RouterProvider
} from 'react-router-dom';
import { registrationRoutes } from '@/registration/pages';

export const router = createBrowserRouter([
  {
    path: '/event/:tenantCode/',
    children: Object.values(registrationRoutes)
  },
]);

export const Router: FC = () => (
  <RouterProvider router={router} />
);
